import React, { useEffect, useRef, useState } from "react";

const LoadingRadar: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => setIsPaused(!entry.isIntersecting),
      { threshold: 0.1 }
    );
    observer.observe(el);

    const handleVisibility = () => {
      if (document.visibilityState === "hidden") setIsPaused(true);
      else if (el) observer.unobserve(el), observer.observe(el); // re-check intersection
    };
    document.addEventListener("visibilitychange", handleVisibility);

    return () => {
      observer.disconnect();
      document.removeEventListener("visibilitychange", handleVisibility);
    };
  }, []);

  return (
    <div
      ref={containerRef}
      className="relative flex items-center justify-center w-[120px] h-[120px] rounded-full border border-border shadow-[25px_25px_75px_rgba(0,0,0,0.15)] overflow-hidden bg-card"
    >
      <div className="absolute inset-5 rounded-full border border-dashed border-border/60 shadow-[inset_-5px_-5px_25px_rgba(0,0,0,0.05),inset_5px_5px_35px_rgba(0,0,0,0.05)]" />
      <div className="absolute w-[40px] h-[40px] rounded-full border border-dashed border-border/60 shadow-[inset_-5px_-5px_25px_rgba(0,0,0,0.05),inset_5px_5px_35px_rgba(0,0,0,0.05)]" />

      <span
        className="absolute top-1/2 left-1/2 w-1/2 h-full bg-transparent origin-top-left border-t border-dashed border-primary/40"
        style={{ animationPlayState: isPaused ? "paused" : "running", animation: "radar81 2s linear infinite" }}
      >
        <span
          className="absolute top-0 left-0 w-full h-full origin-top-left rotate-[-55deg] blur-[30px] drop-shadow-[20px_20px_20px_hsl(var(--primary))]"
          style={{ backgroundColor: "hsl(var(--primary) / 0.5)" }}
        />
      </span>

      <style>{`
        @keyframes radar81 {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default LoadingRadar;
